import { Grid } from '@mui/joy'

import { DatePickerInput, NumericInput } from '~/shared/ui/Form'
import { Container, ContainerTitle } from '~/shared/ui/Layout'

type PaymentProps = {
  loading: boolean
}

export function Payment({ loading }: PaymentProps) {
  return (
    <Container>
      <ContainerTitle>Оплата</ContainerTitle>
      <Grid container spacing={2.5}>
        <Grid xs={6}>
          <NumericInput
            label='Сумма штрафа (без скидки)'
            name='paymentAmountTotal'
            readOnly
            skeletonShow={loading}
            numericProps={{
              suffix: ' руб',
            }}
          />
        </Grid>
        <Grid xs={6}>
          <NumericInput
            label='К оплате'
            name='paymentAmount'
            readOnly
            skeletonShow={loading}
            numericProps={{
              suffix: ' руб',
            }}
          />
        </Grid>

        <Grid xs={6}>
          <DatePickerInput
            label='Окончание скидки'
            name='paymentDiscountDate'
            readOnly
            skeletonShow={loading}
          />
        </Grid>
      </Grid>
    </Container>
  )
}
